import { render, staticRenderFns } from "./ClientesEvolucaoTicketCliente.vue?vue&type=template&id=c3dfb172&scoped=true&"
import script from "./ClientesEvolucaoTicketCliente.vue?vue&type=script&lang=js&"
export * from "./ClientesEvolucaoTicketCliente.vue?vue&type=script&lang=js&"
import style0 from "./ClientesEvolucaoTicketCliente.vue?vue&type=style&index=0&id=c3dfb172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dfb172",
  null
  
)

export default component.exports